import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotTicker from "./components/HotTicker";
import Methods from "./components/Methods";
import Flow from "./components/Flow";
import Tips from "./components/Tips";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotTicker />
        <Methods />
        <Flow />
        <Tips />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />

      <a
        href="#top"
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg shadow-primary-950/20 transition-all hover:bg-primary-600 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
      </a>
    </div>
  );
}